//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            activePlanetIndex: -1,
            planets: [
                {
                    name: this.$store.getters.getPlanetByWeek(1).name[this.$lang.locale],
                    active: this.$store.getters.hasUserFinishedWeek(1) || this.$store.getters.currentWeek === 1,
                    questionIndex: 0,
                    questions: [
                        {
                            route: 'w1d1game1',
                            title: this.$lang.get('helpers.questions.w1d1game1a'),
                            text: this.$lang.get('helpers.questions.w1d1game1b', {br: '\n'})
                        },
                        {
                            route: 'w1d1game3',
                            title: this.$lang.get('helpers.questions.w1d1game3a'),
                            text: this.$lang.get('helpers.questions.w1d1game3b', {br: '\n'})
                        },
                        {
                            route: 'w1d1game4',
                            title: this.$lang.get('helpers.questions.w1d1game4a'),
                            text: this.$lang.get('helpers.questions.w1d1game4b', {br: '\n'})
                        },
                        {
                            route: 'w1d1game6',
                            title: this.$lang.get('helpers.questions.w1d1game6a'),
                            text: this.$lang.get('helpers.questions.w1d1game6b', {br: '\n'})
                        },
                        {
                            route: 'w1d2game5',
                            title: this.$lang.get('helpers.questions.w1d2game5a'),
                            text: this.$lang.get('helpers.questions.w1d2game5b', {br: '\n'})
                        },
                        {
                            route: 'w1d3game1',
                            title: this.$lang.get('helpers.questions.w1d3game1a'),
                            text: this.$lang.get('helpers.questions.w1d3game1b', {br: '\n'})
                        },
                        {
                            route: 'w1d3game2',
                            title: this.$lang.get('helpers.questions.w1d3game2a'),
                            text: this.$lang.get('helpers.questions.w1d3game2b', {br: '\n'})
                        },
                        {
                            route: 'w1d4game1',
                            title: this.$lang.get('helpers.questions.w1d4game1a'),
                            text: this.$lang.get('helpers.questions.w1d4game1b', {br: '\n'})
                        },
                        {
                            route: 'w1d4game2',
                            title: this.$lang.get('helpers.questions.w1d4game2a'),
                            text: this.$lang.get('helpers.questions.w1d4game2b', {br: '\n'})
                        },
                        {
                            route: 'w1d5game1',
                            title: this.$lang.get('helpers.questions.w1d5game1a'),
                            text: this.$lang.get('helpers.questions.w1d5game1b', {br: '\n'})
                        }
                    ]
                },
                {
                    name: this.$store.getters.getPlanetByWeek(2).name[this.$lang.locale],
                    active: this.$store.getters.hasUserFinishedWeek(2) || this.$store.getters.currentWeek === 2,
                    questionIndex: 0,
                    questions: [
                        {
                            route: 'w2d1game1',
                            title: this.$lang.get('helpers.questions.w2d1game1a'),
                            text: this.$lang.get('helpers.questions.w2d1game1b', {br: '\n'})
                        },
                        {
                            route: 'w2d1game3',
                            title: this.$lang.get('helpers.questions.w2d1game3a'),
                            text: this.$lang.get('helpers.questions.w2d1game3b', {br: '\n'})
                        },
                        {
                            route: 'w2d2game1',
                            title: this.$lang.get('helpers.questions.w2d2game1a'),
                            text: this.$lang.get('helpers.questions.w2d2game1b', {br: '\n'})
                        },
                        {
                            route: 'w2d3game3',
                            title: this.$lang.get('helpers.questions.w2d3game3a'),
                            text: this.$lang.get('helpers.questions.w2d3game3b', {br: '\n'})
                        },
                        {
                            route: 'w2d4game3',
                            title: this.$lang.get('helpers.questions.w2d4game3a'),
                            text: this.$lang.get('helpers.questions.w2d4game3b', {br: '\n'})
                        },
                        {
                            route: 'w2d5game1',
                            title: this.$lang.get('helpers.questions.w2d5game1a'),
                            text: this.$lang.get('helpers.questions.w2d5game1b', {br: '\n'})
                        }
                    ]
                },
                {
                    name: this.$store.getters.getPlanetByWeek(3).name[this.$lang.locale],
                    active: this.$store.getters.hasUserFinishedWeek(3) || this.$store.getters.currentWeek === 3,
                    questionIndex: 0,
                    questions: [
                        {
                            route: 'w3d1game1',
                            title: this.$lang.get('helpers.questions.w3d1game1a'),
                            text: this.$lang.get('helpers.questions.w3d1game1b', {br: '\n'})
                        },
                        {
                            route: 'w3d1game3',
                            title: this.$lang.get('helpers.questions.w3d1game3a'),
                            text: this.$lang.get('helpers.questions.w3d1game3b', {br: '\n'})
                        },
                        {
                            route: 'w3d2game3',
                            title: this.$lang.get('helpers.questions.w3d2game3a'),
                            text: this.$lang.get('helpers.questions.w3d2game3b', {br: '\n'})
                        },
                        {
                            route: 'w3d3game5',
                            title: this.$lang.get('helpers.questions.w3d3game5a'),
                            text: this.$lang.get('helpers.questions.w3d3game5b', {br: '\n'})
                        },
                        {
                            route: 'w3d3game6',
                            title: this.$lang.get('helpers.questions.w3d3game6a'),
                            text: this.$lang.get('helpers.questions.w3d3game6b', {br: '\n'})
                        },
                        {
                            route: 'w3d4game2',
                            title: this.$lang.get('helpers.questions.w3d4game2a'),
                            text: this.$lang.get('helpers.questions.w3d4game2b', {br: '\n'})
                        },
                        {
                            route: 'w3d4game4',
                            title: this.$lang.get('helpers.questions.w3d4game4a'),
                            text: this.$lang.get('helpers.questions.w3d4game4b', {br: '\n'})
                        },
                        {
                            route: 'w3d5game1',
                            title: this.$lang.get('helpers.questions.w3d5game1a'),
                            text: this.$lang.get('helpers.questions.w3d5game1b', {br: '\n'})
                        }
                    ]
                },
                {
                    name: this.$store.getters.getPlanetByWeek(4).name[this.$lang.locale],
                    active: this.$store.getters.hasUserFinishedWeek(4) || this.$store.getters.currentWeek === 4,
                    questionIndex: 0,
                    questions: [
                        {
                            route: 'w4d1game1',
                            title: this.$lang.get('helpers.questions.w4d1game1a'),
                            text: this.$lang.get('helpers.questions.w4d1game1b', {br: '\n'})
                        },
                        {
                            route: 'w4d1game2',
                            title: this.$lang.get('helpers.questions.w4d1game2a'),
                            text: this.$lang.get('helpers.questions.w4d1game2b', {br: '\n'})
                        },
                        {
                            route: 'w4d2game1',
                            title: this.$lang.get('helpers.questions.w4d2game1a'),
                            text: this.$lang.get('helpers.questions.w4d2game1b', {br: '\n'})
                        },
                        {
                            route: 'w4d2game2',
                            title: this.$lang.get('helpers.questions.w4d2game2a'),
                            text: this.$lang.get('helpers.questions.w4d2game2b', {br: '\n'})
                        },
                        {
                            route: 'w4d2game5',
                            title: this.$lang.get('helpers.questions.w4d2game5a'),
                            text: this.$lang.get('helpers.questions.w4d2game5b', {br: '\n'})
                        },
                        {
                            route: 'w4d3game2',
                            title: this.$lang.get('helpers.questions.w4d3game2a'),
                            text: this.$lang.get('helpers.questions.w4d3game2b', {br: '\n'})
                        },
                        {
                            route: 'w4d3game5',
                            title: this.$lang.get('helpers.questions.w4d3game5a'),
                            text: this.$lang.get('helpers.questions.w4d3game5b', {br: '\n'})
                        },
                        {
                            route: 'w4d4game3',
                            title: this.$lang.get('helpers.questions.w4d4game3a'),
                            text: this.$lang.get('helpers.questions.w4d4game3b', {br: '\n'})
                        },
                        {
                            route: 'w4d4game4',
                            title: this.$lang.get('helpers.questions.w4d4game4a'),
                            text: this.$lang.get('helpers.questions.w4d4game4b', {br: '\n'})
                        },
                        {
                            route: 'w4d5game1',
                            title: this.$lang.get('helpers.questions.w4d5game1a'),
                            text: this.$lang.get('helpers.questions.w4d5game1b', {br: '\n'})
                        }
                    ]
                }
            ]
        };
    },

    computed: {
        activePlanet () {
            return this.planets[this.activePlanetIndex];
        }
    },

    created () {
        if (this.$route.params && this.$route.params.gameroute) {
            let planetIndex = this.planets.findIndex(planet => planet.questions.some(question => question.route === this.$route.params.gameroute));

            if (planetIndex !== -1) {
                this.activePlanetIndex = planetIndex;
                this.activePlanet.questionIndex = this.activePlanet.questions.findIndex(question => question.route === this.$route.params.gameroute);
            }
        }
    }
};
